import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { User,Client } from '../models/user';
import { Observable } from 'rxjs';
const httpOptions = {
  headers: new HttpHeaders({
    "content-type": "application/json",
    "cache-control": "no-cache",
    "postman-token": "328e0245-1550-661f-0e4c-81b0b27cbda1"
    
  })
};
@Injectable({
  providedIn: 'root'
})
export class UserService {
  currentUser : User;
  currentClient : Client;
  constructor(private http: HttpClient) { 

    //this.currentUser = { "id": 1, email: "user_sans_loginsimuleo.com","data_user":[]}
  }

   
    getUserUuid(uuid: string) {
      return this.http.get<any>(`https://stats.simuleo.com/counters/`+uuid);
    }

    setCurrentUser(user:User){
      this.currentUser = user;
    }

    setCurrentClient(client:Client){
      this.currentClient = client;
    }

    getCurrentUser():User {
      return this.currentUser;
    }
    getCountertUser(uuid: string) {
      return this.http.get<any>(`https://stats.simuleo.com/counters/`+uuid);
          
    }

    getCurrentClient():Client {
      return this.currentClient;
    }

    postStatData(data:any){
     
      return  this.http.post<any>('https://stats.simuleo.com/data', data).subscribe(data => {})
  
    }

    getUserProfil(email:any){
     
      return  this.http.get<any>(`/simulation/simuleo/getUserByEmail/` +email);
  
    }
    getArchives(id:any,partenaire:any){
     
      return  this.http.get<any>(`/simulation/simuleo/getPdf/` +id+`/`+partenaire);
  
    }
    deleteArchives(id:any){
      
     
      return  this.http.post<any>(`simulation/simuleo/deleteArchive/`, id).subscribe(data => {
        console.log(data);
      });
  
    }

    public sendPdfMail(email,name){
     
      let data ={ "name":name,"email":email};

      return  this.http.post<any>('/send-mail/swao-mail.php', data); 
      
       
    } 


  
}
